import * as t from "./actions"

export interface MetricViewState{
  group_by:string
  compare_by: string
  view: string
  metric_data:any[]
  fullscreen: boolean
  flyers: any[]
  selectedFlyerId: number
  selectedPublicationId: number
  flyerItems: any[]
  flyer_items_loading: boolean
  flyersLoading:boolean
  metric_data_loading: boolean
  topline_metrics_loading: boolean
  toplineMetrics : ToplineMetricsState
  sfmlErrorMessage: string|null,
  sfmlData: any,
}

export interface ToplineMetricsState{
  yoy_aggregate:number,
  yoy_delta:number,
  yoy_percent_delta: number,
  year_to_month_aggregate:number,
  year_to_month_delta:number,
  year_to_month_percent_delta: number,
  month_to_date_aggregate: number,
  month_to_date_delta: number,
  month_to_date_percent_delta: number
}

let initialState: MetricViewState = {
  metric_data: [],
  flyers: [],
  flyerItems: [],
  selectedFlyerId: null,
  selectedPublicationId: null,
  compare_by: null,
  group_by: null,
  view: null,
  fullscreen: false,
  toplineMetrics : null,
  flyer_items_loading: false,
  metric_data_loading: false,
  topline_metrics_loading: false,
  flyersLoading:false,
  sfmlErrorMessage: null,
  sfmlData: null,
}

export default function (state = initialState, action: IPayload): MetricViewState {
  switch (action.type) {

    case t.CLEAR_METRIC_DATA:
      state = {...state, metric_data : []}
      return state

    case t.SET_METRIC_DATA_LOADING:
      state = {...state, metric_data_loading:action.payload}
      return state

    case t.SET_METRIC_DATA:
      state = {...state, metric_data : action.payload.metric_data }
      return state

    case t.GET_METRIC_DATA_FAILURE:
      return state

    case t.SET_METRIC_CONTENT_GROUP_BY:
      state ={...state, group_by: action.payload}
      return state

    case t.SET_METRIC_CONTENT_COMPARE_BY:
      state ={...state, compare_by: action.payload}
      return state

    case t.SET_METRIC_CONTENT_VIEW:
      state ={...state, view: action.payload}
      return state
    case t.GET_TOPLINE_METRICS:
      return state
    case t.ADD_TOPLINE_METRICS:
      state = {...state, toplineMetrics : action.payload }
      return state
    case t.GET_TOPLINE_METRICS_FAILURE:
      return state;

    case t.GET_FLYERS_FAILURE:
      return state

    case t.SET_FLYERS:
      state = { ...state, flyers: action.payload }
      return state

    case t.SET_FLYERS_LOADING:
      state = {...state, flyersLoading : action.payload}
      return state

    case t.SET_SELECTED_FLYER_ID:
      state = { ...state, selectedFlyerId: action.payload }
      return state

    case t.SET_FLYER_ITEMS_LOADING:
      state = {...state, flyer_items_loading: action.payload}
      return state

    case t.GET_FLYER_ITEMS_FAILURE:
      return state

    case t.SET_FLYER_ITEMS:
      state = { ...state, flyerItems: action.payload }
      return state

    case t.CLEAR_FLYER_ITEMS:
      state = { ...state, flyerItems: []}
      return state

    case t.SET_SELECTED_PUBLICATION_ID:
      state = { ...state, selectedPublicationId: action.payload}
      return state

    case t.SET_TOPLINE_METRICS_LOADING:
      state = {...state, topline_metrics_loading:action.payload}
      return state

    case t.SET_SFML_ERROR_MESSAGE:
      state = { ...state, sfmlErrorMessage: action.payload }
      return state
    case t.SAVE_SFML_DATA:
      state = {...state, sfmlData: action.payload}
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/reducer.ts